// todo: move to respective module

import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { ToastService } from '@shared/modules/toast/services/toast.service';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';

@Injectable()
export class BDDGITErrorHandlerInterceptor implements HttpInterceptor {
  private readonly gitBaseURL: string;
  constructor(private toastService: ToastService, private runTimeConfigService: RunTimeConfigService) {
    this.gitBaseURL = this.runTimeConfigService.getConfig('baseURLConfig').git.baseURL;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf(this.gitBaseURL) === -1) {
      return next.handle(req);
    }

    return next
      .handle(req)
      .pipe(finalize(() => {}))
      .pipe(
        tap((ev: HttpEvent<any>) => {}),
        catchError(response => {
          if (response instanceof HttpErrorResponse && req.url.indexOf(this.gitBaseURL) > -1) {
            if (response.status === 404) {
              this.toastService.showToast(
                'app.lang.bdd.BDDGITErrorHandlerInterceptor.pleaseEnterExistingGITRepoBranchNameAndCredentials',
                'toastError'
              );
            }
          }

          return throwError(response);
        })
      );
  }
}
